import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: Date; output: Date; }
  JSON: { input: any; output: any; }
};

export type AcceptPrivacyPolicyInput = {
  isAccepted: Scalars['Boolean']['input'];
  policyId: Scalars['String']['input'];
};

export type AcceptPrivacyPolicyOutput = {
  __typename?: 'AcceptPrivacyPolicyOutput';
  userPrivacyPolicyAcceptance: UserPrivacyPolicyAcceptance;
};

export type AcceptTermAndConditionInput = {
  isAccepted: Scalars['Boolean']['input'];
  termAndConditionId: Scalars['String']['input'];
};

export type AcceptTermAndConditionOutput = {
  __typename?: 'AcceptTermAndConditionOutput';
  userTermAndConditionAcceptance: UserTermAndConditionAcceptance;
};

export type BackToExamRoomInput = {
  examCardId: Scalars['String']['input'];
  isReset: Scalars['Boolean']['input'];
};

export type CheckUserAcceptanceForLatestPrivacyPolicyOutput = {
  __typename?: 'CheckUserAcceptanceForLatestPrivacyPolicyOutput';
  isAccepted: Scalars['Boolean']['output'];
  privacyPolicy: PrivacyPolicy;
};

export type CheckUserAcceptanceForLatestTermAndConditionOutput = {
  __typename?: 'CheckUserAcceptanceForLatestTermAndConditionOutput';
  isAccepted: Scalars['Boolean']['output'];
  termAndCondition: TermAndCondition;
};

export type CheckUserPrivacyPolicyAcceptanceInput = {
  policyId: Scalars['String']['input'];
};

export type CheckUserPrivacyPolicyAcceptanceOutput = {
  __typename?: 'CheckUserPrivacyPolicyAcceptanceOutput';
  isAccepted: Scalars['Boolean']['output'];
  privacyPolicy: Maybe<UserPrivacyPolicyAcceptance>;
};

export type CheckUserTermAndConditionAcceptanceInput = {
  termAndConditionId: Scalars['String']['input'];
};

export type CheckUserTermAndConditionAcceptanceOutput = {
  __typename?: 'CheckUserTermAndConditionAcceptanceOutput';
  isAccepted: Scalars['Boolean']['output'];
  termAndCondition: Maybe<UserTermAndConditionAcceptance>;
};

export type ClientUser = {
  __typename?: 'ClientUser';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  enabledAt: Maybe<Scalars['DateTime']['output']>;
  expiredAt: Scalars['DateTime']['output'];
  firstname: Scalars['String']['output'];
  id: Scalars['String']['output'];
  idNumber: Scalars['String']['output'];
  idType: IdType;
  imageUrl: Maybe<Scalars['String']['output']>;
  lastname: Scalars['String']['output'];
  middleName: Maybe<Scalars['String']['output']>;
  password: Scalars['String']['output'];
  status: UserStratus;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userPrivacyPolicies: Array<UserPrivacyPolicyAcceptance>;
  username: Scalars['String']['output'];
};

export type CreatePrivacyPolicyInput = {
  description: Scalars['String']['input'];
  documentUrl: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  version: Scalars['String']['input'];
};

export type CreatePrivacyPolicyOutput = {
  __typename?: 'CreatePrivacyPolicyOutput';
  privacyPolicy: PrivacyPolicy;
};

export type CreateTermAndConditionInput = {
  description: Scalars['String']['input'];
  documentUrl: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  version: Scalars['String']['input'];
};

export type CreateTermAndConditionOutput = {
  __typename?: 'CreateTermAndConditionOutput';
  termAndCondition: TermAndCondition;
};

export enum Exam_Event_Type {
  Sat = 'SAT',
  SatMock = 'SAT_MOCK',
  SatPractice = 'SAT_PRACTICE'
}

export enum Exam_Generator_Type {
  Fixed = 'FIXED',
  FixedAll = 'FIXED_ALL',
  Random = 'RANDOM'
}

export enum Exam_Module_Type {
  Break = 'BREAK',
  Exam = 'EXAM',
  Finish = 'FINISH'
}

export enum Exam_Status {
  Deprecated = 'DEPRECATED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export enum Exam_Type {
  Lol = 'LOL',
  Sat = 'SAT',
  SatMock = 'SAT_MOCK',
  SatPractice = 'SAT_PRACTICE',
  Set = 'SET'
}

export type Exam = {
  __typename?: 'Exam';
  defaultGeneratorType: Exam_Generator_Type;
  examItems: Array<ExamItem>;
  examSubjects: Maybe<Array<ExamSubject>>;
  fullScore: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  metadata: Maybe<Scalars['JSON']['output']>;
  ownerCode: Scalars['String']['output'];
  status: Exam_Status;
  tags: Maybe<Array<ExamTag>>;
  title: Scalars['String']['output'];
  totalQuestions: Maybe<Scalars['Int']['output']>;
  type: Maybe<Exam_Type>;
};

export type ExamCard = {
  __typename?: 'ExamCard';
  additionalEmail: Maybe<Scalars['String']['output']>;
  availableDate: Maybe<Scalars['DateTime']['output']>;
  examEventId: Maybe<Scalars['String']['output']>;
  expiryDate: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  metadata: Maybe<Scalars['JSON']['output']>;
  seatNumber: Maybe<Scalars['Float']['output']>;
  skuExamId: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type ExamEvent = {
  __typename?: 'ExamEvent';
  coverImageUrl: Maybe<Scalars['String']['output']>;
  displayConfig: Maybe<Scalars['JSON']['output']>;
  endDate: Maybe<Scalars['DateTime']['output']>;
  exam: Maybe<Exam>;
  examId: Maybe<Scalars['String']['output']>;
  generatorConfig: Maybe<Scalars['JSON']['output']>;
  id: Scalars['String']['output'];
  instructions: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['JSON']['output']>;
  postponeDurationInMs: Maybe<Scalars['Int']['output']>;
  startDate: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  subTitle: Maybe<Scalars['String']['output']>;
  timeLimit: Maybe<Scalars['Float']['output']>;
  title: Scalars['String']['output'];
  type: Maybe<Exam_Event_Type>;
  userConfig: Maybe<Scalars['JSON']['output']>;
};

export type ExamItem = {
  __typename?: 'ExamItem';
  examId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  question: Maybe<Question>;
  questionId: Maybe<Scalars['String']['output']>;
  refId: Maybe<Scalars['String']['output']>;
  refType: Maybe<ExamItemReferenceType>;
  score: Scalars['Float']['output'];
};

export enum ExamItemReferenceType {
  Exam = 'EXAM',
  Question = 'QUESTION'
}

export type ExamPaper = {
  __typename?: 'ExamPaper';
  createdAt: Scalars['DateTime']['output'];
  examCardId: Scalars['String']['output'];
  examId: Scalars['String']['output'];
  examPaperItems: Array<ExamPaperItem>;
  fullScore: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  iteration: Scalars['Int']['output'];
  refId: Scalars['String']['output'];
  remainingTime: Maybe<Scalars['Int']['output']>;
  score: Scalars['Float']['output'];
  startedAt: Maybe<Scalars['DateTime']['output']>;
  status: ExamPaperStatus;
  submittedAt: Maybe<Scalars['DateTime']['output']>;
  timeLimit: Maybe<Scalars['Int']['output']>;
  totalCorrectQuestions: Scalars['Int']['output'];
  totalQuestions: Scalars['Int']['output'];
};

export type ExamPaperItem = {
  __typename?: 'ExamPaperItem';
  examPaperId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  question: Maybe<Question>;
  questionId: Maybe<Scalars['String']['output']>;
  refId: Maybe<Scalars['String']['output']>;
  refType: Maybe<ExamItemReferenceType>;
  score: Scalars['Float']['output'];
};

export enum ExamPaperStatus {
  Finished = 'FINISHED',
  Grading = 'GRADING',
  InProgress = 'IN_PROGRESS',
  TimeUp = 'TIME_UP'
}

export type ExamResult = {
  __typename?: 'ExamResult';
  examCardId: Scalars['String']['output'];
  examId: Scalars['String']['output'];
  fullScore: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  isPassed: Scalars['Boolean']['output'];
  score: Scalars['Float']['output'];
};

export type ExamRoomAnswer = {
  __typename?: 'ExamRoomAnswer';
  createdAt: Scalars['DateTime']['output'];
  examPaperId: Scalars['String']['output'];
  examRoomExamPaperItems: Maybe<Array<ExamRoomExamPaperItem>>;
};

export type ExamRoomExamInfo = {
  __typename?: 'ExamRoomExamInfo';
  duration: Maybe<Scalars['Int']['output']>;
  endedAt: Maybe<Scalars['String']['output']>;
  examId: Maybe<Scalars['String']['output']>;
  type: Exam_Module_Type;
};

export type ExamRoomExamPaperItem = {
  __typename?: 'ExamRoomExamPaperItem';
  answer: Scalars['JSON']['output'];
  examPaperItemId: Scalars['String']['output'];
  isBookmark: Scalars['Boolean']['output'];
  questionId: Maybe<Scalars['String']['output']>;
  refId: Maybe<Scalars['String']['output']>;
  refType: Maybe<ExamItemReferenceType>;
};

export type ExamRoomExamPaperItemInput = {
  answer: Scalars['JSON']['input'];
  examPaperItemId: Scalars['String']['input'];
  isBookmark: Scalars['Boolean']['input'];
  questionId?: InputMaybe<Scalars['String']['input']>;
  refId?: InputMaybe<Scalars['String']['input']>;
  refType?: InputMaybe<ExamItemReferenceType>;
};

export type ExamSession = {
  __typename?: 'ExamSession';
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  endedAt: Maybe<Scalars['DateTime']['output']>;
  examEventId: Maybe<Scalars['String']['output']>;
  examPaperId: Scalars['String']['output'];
  examRoomAnswer: Maybe<ExamRoomAnswer>;
  finishedAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  isSetTimer: Scalars['Boolean']['output'];
  startedAt: Scalars['DateTime']['output'];
};

export type ExamSubject = {
  __typename?: 'ExamSubject';
  id: Scalars['String']['output'];
  tagId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  totalQuestionCount: Scalars['Int']['output'];
};

export type ExamTag = {
  __typename?: 'ExamTag';
  category: QbTagCategory;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type ExaminationTime = {
  __typename?: 'ExaminationTime';
  current: Scalars['Boolean']['output'];
  extraDurationInMs: Scalars['Int']['output'];
  postponedDurationInMs: Scalars['Int']['output'];
  round: Scalars['Int']['output'];
  totalManualExtendedDurationInMs: Scalars['Int']['output'];
};

export type ExamineeInfo = {
  __typename?: 'ExamineeInfo';
  firstName: Scalars['String']['output'];
  hasCertificate: Scalars['Boolean']['output'];
  isDisplayResult: Scalars['Boolean']['output'];
  isPassed: Maybe<Scalars['Boolean']['output']>;
  lastName: Scalars['String']['output'];
  middleName: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type GetAllPrivacyPoliciesInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetAllPrivacyPoliciesOutput = {
  __typename?: 'GetAllPrivacyPoliciesOutput';
  privacyPolicies: Array<PrivacyPolicy>;
};

export type GetAllTermAndConditionsInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetAllTermAndConditionsOutput = {
  __typename?: 'GetAllTermAndConditionsOutput';
  termAndConditions: Array<TermAndCondition>;
};

export type GetDownloadSignedUrlForMyAttachDocumentResult = {
  __typename?: 'GetDownloadSignedUrlForMyAttachDocumentResult';
  signedUrl: Scalars['String']['output'];
};

export type GetDownloadSignedUrlForQuestionsInput = {
  examId: Scalars['String']['input'];
};

export type GetDownloadSignedUrlForQuestionsResult = {
  __typename?: 'GetDownloadSignedUrlForQuestionsResult';
  signedUrls: Scalars['JSON']['output'];
};

export type GetLatestActivePrivacyPolicyOutput = {
  __typename?: 'GetLatestActivePrivacyPolicyOutput';
  privacyPolicy: PrivacyPolicy;
};

export type GetLatestActiveTermAndConditionOutput = {
  __typename?: 'GetLatestActiveTermAndConditionOutput';
  termAndCondition: TermAndCondition;
};

export type GetPrivacyPolicyByIdOutput = {
  __typename?: 'GetPrivacyPolicyByIdOutput';
  privacyPolicy: PrivacyPolicy;
};

export type GetPrivacyPolicyByUdInput = {
  id: Scalars['String']['input'];
};

export type GetTermAndConditionByIdInput = {
  id: Scalars['String']['input'];
};

export type GetTermAndConditionByIdOutput = {
  __typename?: 'GetTermAndConditionByIdOutput';
  termAndCondition: TermAndCondition;
};

export type GetUserByTokenInput = {
  token: Scalars['String']['input'];
};

export type GetUserByTokenOutput = {
  __typename?: 'GetUserByTokenOutput';
  user: ClientUser;
};

export type GetUserImageDownloadSignedUrlOutput = {
  __typename?: 'GetUserImageDownloadSignedUrlOutput';
  signedUrls: Scalars['JSON']['output'];
};

export type GetUserPrivacyPoliciesInput = {
  acceptOption?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetUserPrivacyPoliciesOutput = {
  __typename?: 'GetUserPrivacyPoliciesOutput';
  userPrivacyPolicyAcceptances: Array<UserPrivacyPolicyAcceptance>;
};

export type GetUserTermAndConditionAcceptancesInput = {
  acceptOption?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetUserTermAndConditionAcceptancesOutput = {
  __typename?: 'GetUserTermAndConditionAcceptancesOutput';
  userTermAndConditionAcceptances: Array<UserTermAndConditionAcceptance>;
};

export enum IdType {
  CitizenCard = 'CITIZEN_CARD',
  Passport = 'PASSPORT'
}

export type Login = {
  __typename?: 'Login';
  errorCode: Maybe<LoginErrorCode>;
  examineeInfo: Maybe<ExamineeInfo>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  token: Maybe<Scalars['String']['output']>;
};

export enum LoginErrorCode {
  ExamFinished = 'EXAM_FINISHED',
  ExamNotReady = 'EXAM_NOT_READY',
  ExamTypeNotSupported = 'EXAM_TYPE_NOT_SUPPORTED',
  SystemError = 'SYSTEM_ERROR',
  UsernameOrPasswordIncorrect = 'USERNAME_OR_PASSWORD_INCORRECT',
  UserAbsent = 'USER_ABSENT',
  UserBlocked = 'USER_BLOCKED',
  UserNotActive = 'USER_NOT_ACTIVE',
  UserNotEnabled = 'USER_NOT_ENABLED',
  UserNotRegistered = 'USER_NOT_REGISTERED'
}

export type LoginInput = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type Logout = {
  __typename?: 'Logout';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  cluAcceptPrivacyPolicy: AcceptPrivacyPolicyOutput;
  cluAcceptTermAndCondition: AcceptTermAndConditionOutput;
  cluCreatePrivacyPolicy: CreatePrivacyPolicyOutput;
  cluCreateTermAndCondition: CreateTermAndConditionOutput;
  cluUpdatePrivacyPolicy: UpdatePrivacyPolicyOutput;
  cluUpdateTermAndCondition: UpdateTermAndConditionOutput;
  erBackToExamRoom: ExamSession;
  erExamRoomUpdateExamPaper: ExamRoomAnswer;
  erLogin: Login;
  erLogout: Logout;
  erResolveNextExamModuleInfo: ExamRoomExamInfo;
  erSaveQuestionnaire: QuestionnaireDocument;
  erStartExamInEvent: StartExamInEvent;
  erSubmitExamPaper: SubmitExamPaperResult;
  erUpdateExamCardAdditionalEmail: ExamCard;
};


export type MutationCluAcceptPrivacyPolicyArgs = {
  AcceptPrivacyPolicyInput: AcceptPrivacyPolicyInput;
};


export type MutationCluAcceptTermAndConditionArgs = {
  AcceptTermAndConditionInput: AcceptTermAndConditionInput;
};


export type MutationCluCreatePrivacyPolicyArgs = {
  CreatePrivacyPolicyInput: CreatePrivacyPolicyInput;
};


export type MutationCluCreateTermAndConditionArgs = {
  CreateTermAndConditionInput: CreateTermAndConditionInput;
};


export type MutationCluUpdatePrivacyPolicyArgs = {
  UpdatePrivacyPolicyInput: UpdatePrivacyPolicyInput;
};


export type MutationCluUpdateTermAndConditionArgs = {
  UpdateTermAndConditionInput: UpdateTermAndConditionInput;
};


export type MutationErBackToExamRoomArgs = {
  input: BackToExamRoomInput;
};


export type MutationErExamRoomUpdateExamPaperArgs = {
  examRoomExamPaperItems: Array<ExamRoomExamPaperItemInput>;
};


export type MutationErLoginArgs = {
  input: LoginInput;
};


export type MutationErResolveNextExamModuleInfoArgs = {
  examCardId: Scalars['String']['input'];
};


export type MutationErSaveQuestionnaireArgs = {
  input: SaveQuestionnaireInput;
};


export type MutationErStartExamInEventArgs = {
  input: StartExamInEventInput;
};


export type MutationErSubmitExamPaperArgs = {
  submitExamInput: SubmitExamInput;
};


export type MutationErUpdateExamCardAdditionalEmailArgs = {
  email: Scalars['String']['input'];
  examCardId: Scalars['String']['input'];
};

export type MyExaminationTime = {
  __typename?: 'MyExaminationTime';
  examinationTime: Array<ExaminationTime>;
};

export type PrivacyPolicy = {
  __typename?: 'PrivacyPolicy';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  documentUrl: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['String']['output'];
};

export enum QbQuestionStatus {
  Deprecated = 'DEPRECATED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export enum QbQuestionType {
  FillInTheBlank = 'FILL_IN_THE_BLANK',
  FillNumber = 'FILL_NUMBER',
  MultipleChoice = 'MULTIPLE_CHOICE',
  MultipleChoiceDifferentScore = 'MULTIPLE_CHOICE_DIFFERENT_SCORE',
  MultipleSelect = 'MULTIPLE_SELECT',
  MultipleSelectWithCorrectAnswers = 'MULTIPLE_SELECT_WITH_CORRECT_ANSWERS',
  MultipleSubQuestionsConnectionAnswers = 'MULTIPLE_SUB_QUESTIONS_CONNECTION_ANSWERS',
  MultipleSubQuestionsYesNoAnswer = 'MULTIPLE_SUB_QUESTIONS_YES_NO_ANSWER',
  SatMathInput = 'SAT_MATH_INPUT'
}

export enum QbTagCategory {
  AllSubTopic = 'ALL_SUB_TOPIC',
  Bloom = 'BLOOM',
  Calculation = 'CALCULATION',
  Chapter = 'CHAPTER',
  CognitiveDomain = 'COGNITIVE_DOMAIN',
  Course = 'COURSE',
  CourseCode = 'COURSE_CODE',
  Difficulty = 'DIFFICULTY',
  ExamCampaign = 'EXAM_CAMPAIGN',
  ExamType = 'EXAM_TYPE',
  Grade = 'GRADE',
  Group = 'GROUP',
  Indicator = 'INDICATOR',
  ItemSet = 'ITEM_SET',
  LearningObjectiveStatement = 'LEARNING_OBJECTIVE_STATEMENT',
  NonSpecificTopic = 'NON_SPECIFIC_TOPIC',
  Objective = 'OBJECTIVE',
  Owner = 'OWNER',
  Part = 'PART',
  QbankStructureLevel = 'QBANK_STRUCTURE_LEVEL',
  QuestionExamType = 'QUESTION_EXAM_TYPE',
  QuestionType = 'QUESTION_TYPE',
  QBankStructure = 'Q_BANK_STRUCTURE',
  QBankStructureLevelItem = 'Q_BANK_STRUCTURE_LEVEL_ITEM',
  QConfig = 'Q_CONFIG',
  SatExamModule = 'SAT_EXAM_MODULE',
  Section = 'SECTION',
  Single = 'SINGLE',
  Subject = 'SUBJECT',
  Subsection = 'SUBSECTION',
  Subtopic = 'SUBTOPIC',
  SubTopic = 'SUB_TOPIC',
  Tag = 'TAG',
  Term = 'TERM',
  Topic = 'TOPIC'
}

export type Query = {
  __typename?: 'Query';
  cluCheckUserAcceptanceForLatestPrivacyPolicy: CheckUserAcceptanceForLatestPrivacyPolicyOutput;
  cluCheckUserAcceptanceForLatestTermAndCondition: CheckUserAcceptanceForLatestTermAndConditionOutput;
  cluCheckUserPrivacyPolicyAcceptance: CheckUserPrivacyPolicyAcceptanceOutput;
  cluCheckUserTermAndConditionAcceptance: CheckUserTermAndConditionAcceptanceOutput;
  cluGetAllPrivacyPolicies: GetAllPrivacyPoliciesOutput;
  cluGetAllTermAndConditions: GetAllTermAndConditionsOutput;
  cluGetLatestActivePrivacyPolicy: GetLatestActivePrivacyPolicyOutput;
  cluGetLatestActiveTermAndCondition: GetLatestActiveTermAndConditionOutput;
  cluGetMyProfile: ClientUser;
  cluGetPrivacyPolicyById: GetPrivacyPolicyByIdOutput;
  cluGetTermAndConditionById: GetTermAndConditionByIdOutput;
  cluGetUserByToken: GetUserByTokenOutput;
  cluGetUserImageDownloadSignedUrl: GetUserImageDownloadSignedUrlOutput;
  cluGetUserPrivacyPolicies: GetUserPrivacyPoliciesOutput;
  cluGetUserTermAndConditionAcceptances: GetUserTermAndConditionAcceptancesOutput;
  erCheckExamStatusByExamCardId: Maybe<ExamSession>;
  erExamRoomGetExam: Exam;
  erGetDownloadSignedUrlForMyAttachDocument: GetDownloadSignedUrlForMyAttachDocumentResult;
  erGetDownloadSignedUrlForQuestions: Maybe<GetDownloadSignedUrlForQuestionsResult>;
  erGetExamEventByCardId: ExamEvent;
  erGetExamPapersByCardId: Array<ExamPaper>;
  erGetExamResultByCardId: Maybe<ExamResult>;
  erGetExamSessionAnswer: ExamSession;
  erGetExamsByIds: Array<Exam>;
  erGetMyCurrentExamPaper: ExamPaper;
  erGetMyExamCard: ExamCard;
  erGetMyExaminationTime: MyExaminationTime;
  erGetSATExamEventResult: SatExamEventResult;
  erMyLatestFinishedExamCard: Maybe<ExamCard>;
};


export type QueryCluCheckUserPrivacyPolicyAcceptanceArgs = {
  CheckUserPrivacyPolicyInput: CheckUserPrivacyPolicyAcceptanceInput;
};


export type QueryCluCheckUserTermAndConditionAcceptanceArgs = {
  CheckUserTermAndConditionAcceptanceInput: CheckUserTermAndConditionAcceptanceInput;
};


export type QueryCluGetAllPrivacyPoliciesArgs = {
  GetAllPrivacyPoliciesInput: GetAllPrivacyPoliciesInput;
};


export type QueryCluGetAllTermAndConditionsArgs = {
  GetAllTermAndConditionsInput: GetAllTermAndConditionsInput;
};


export type QueryCluGetPrivacyPolicyByIdArgs = {
  GetPrivacyPolicyByIdInput: GetPrivacyPolicyByUdInput;
};


export type QueryCluGetTermAndConditionByIdArgs = {
  GetTermAndConditionByIdInput: GetTermAndConditionByIdInput;
};


export type QueryCluGetUserByTokenArgs = {
  GetUserByTokenInput: GetUserByTokenInput;
};


export type QueryCluGetUserPrivacyPoliciesArgs = {
  GetUserPrivacyPoliciesInput: GetUserPrivacyPoliciesInput;
};


export type QueryCluGetUserTermAndConditionAcceptancesArgs = {
  GetUserTermAndConditionAcceptancesInput: GetUserTermAndConditionAcceptancesInput;
};


export type QueryErCheckExamStatusByExamCardIdArgs = {
  examCardId: Scalars['String']['input'];
};


export type QueryErGetDownloadSignedUrlForMyAttachDocumentArgs = {
  examCardId: Scalars['String']['input'];
};


export type QueryErGetDownloadSignedUrlForQuestionsArgs = {
  input: GetDownloadSignedUrlForQuestionsInput;
};


export type QueryErGetExamEventByCardIdArgs = {
  cardId: Scalars['String']['input'];
};


export type QueryErGetExamPapersByCardIdArgs = {
  examCardId: Scalars['String']['input'];
};


export type QueryErGetExamResultByCardIdArgs = {
  examCardId: Scalars['String']['input'];
};


export type QueryErGetExamsByIdsArgs = {
  examIds: Array<Scalars['String']['input']>;
};


export type QueryErGetMyExaminationTimeArgs = {
  examCardId: Scalars['String']['input'];
};


export type QueryErGetSatExamEventResultArgs = {
  examCardId: Scalars['String']['input'];
};

export type Question = {
  __typename?: 'Question';
  difficulty: Scalars['String']['output'];
  examMaterialId: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metadata: Maybe<Scalars['JSON']['output']>;
  question: Scalars['String']['output'];
  refQuestionId: Scalars['String']['output'];
  refSource: Scalars['String']['output'];
  status: QbQuestionStatus;
  subType: Maybe<Scalars['String']['output']>;
  tags: Array<QuestionTag>;
  type: QbQuestionType;
};

export type QuestionTag = {
  __typename?: 'QuestionTag';
  category: QbTagCategory;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type QuestionnaireDocument = {
  __typename?: 'QuestionnaireDocument';
  documentId: Scalars['String']['output'];
  examCardId: Scalars['String']['output'];
  questionnaire: Scalars['JSON']['output'];
  questionnaireTemplateId: Scalars['String']['output'];
};

export type RawAnswerInput = {
  answer: Scalars['JSON']['input'];
  examPaperItemId: Scalars['String']['input'];
};

export type SatExamAttemptsResult = {
  __typename?: 'SATExamAttemptsResult';
  attempt: Scalars['Int']['output'];
  examPapersBySubject: Array<SatSubjectExamPaper>;
  officialScore: Scalars['JSON']['output'];
  scoresBySubject: Array<SatTagResultObjectType>;
};

export type SatExamEventResult = {
  __typename?: 'SATExamEventResult';
  examCard: ExamCard;
  examEvent: ExamEvent;
  results: Array<SatExamAttemptsResult>;
};

export type SatSubjectExamPaper = {
  __typename?: 'SATSubjectExamPaper';
  examPapers: Array<ExamPaper>;
  moduleNames: Array<Scalars['String']['output']>;
  subjectName: Scalars['String']['output'];
};

export type SatTagResultObjectType = {
  __typename?: 'SATTagResultObjectType';
  correctQuestions: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  scoresByTag: Array<SatTagResultPartial>;
  tagCategory: QbTagCategory;
  tagId: Scalars['String']['output'];
  totalQuestions: Scalars['Int']['output'];
};

export type SatTagResultPartial = {
  __typename?: 'SATTagResultPartial';
  correctQuestions: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  tagCategory: QbTagCategory;
  tagId: Scalars['String']['output'];
  totalQuestions: Scalars['Int']['output'];
};

export type SaveQuestionnaireInput = {
  examCardId: Scalars['String']['input'];
  questionnaire: Scalars['JSON']['input'];
};

export enum StartExamErrorCode {
  ExpiredExamCard = 'EXPIRED_EXAM_CARD',
  NotInSession = 'NOT_IN_SESSION',
  SystemError = 'SYSTEM_ERROR'
}

export type StartExamInEvent = {
  __typename?: 'StartExamInEvent';
  errorCode: Maybe<StartExamErrorCode>;
  examSession: Maybe<ExamSession>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type StartExamInEventInput = {
  examCardId: Scalars['String']['input'];
  isSetTimer: Scalars['Boolean']['input'];
};

export type SubmitExamInput = {
  rawAnswers: Array<RawAnswerInput>;
};

export enum SubmitExamPaperErrorCode {
  ExamCardExpired = 'EXAM_CARD_EXPIRED',
  NotFound = 'NOT_FOUND',
  SystemError = 'SYSTEM_ERROR'
}

export type SubmitExamPaperResult = {
  __typename?: 'SubmitExamPaperResult';
  errorCode: Maybe<SubmitExamPaperErrorCode>;
  examPaper: Maybe<ExamPaper>;
  isSuccess: Scalars['Boolean']['output'];
  message: Maybe<Scalars['String']['output']>;
};

export type TermAndCondition = {
  __typename?: 'TermAndCondition';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  documentUrl: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['String']['output'];
};

export type UpdatePrivacyPolicyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  documentUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePrivacyPolicyOutput = {
  __typename?: 'UpdatePrivacyPolicyOutput';
  privacyPolicy: PrivacyPolicy;
};

export type UpdateTermAndConditionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  documentUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateTermAndConditionOutput = {
  __typename?: 'UpdateTermAndConditionOutput';
  termAndCondition: TermAndCondition;
};

export type UserPrivacyPolicyAcceptance = {
  __typename?: 'UserPrivacyPolicyAcceptance';
  acceptedAt: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  isAccepted: Scalars['Boolean']['output'];
  policyId: Scalars['String']['output'];
  privacyPolicy: PrivacyPolicy;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export enum UserStratus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Revoked = 'REVOKED'
}

export type UserTermAndConditionAcceptance = {
  __typename?: 'UserTermAndConditionAcceptance';
  acceptedAt: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  isAccepted: Scalars['Boolean']['output'];
  termAndCondition: TermAndCondition;
  termAndConditionId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export type ErUpdateExamCardAdditionalEmailMutationVariables = Exact<{
  examCardId: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;


export type ErUpdateExamCardAdditionalEmailMutation = { __typename?: 'Mutation', erUpdateExamCardAdditionalEmail: { __typename?: 'ExamCard', additionalEmail: string | null } };

export type ErGetMyExamCardQueryVariables = Exact<{ [key: string]: never; }>;


export type ErGetMyExamCardQuery = { __typename?: 'Query', erGetMyExamCard: { __typename?: 'ExamCard', id: string, userId: string, examEventId: string | null, availableDate: Date | null, expiryDate: Date | null, metadata: any | null, seatNumber: number | null } };

export type ErGetAdditionalEmailFromMyExamCardQueryVariables = Exact<{ [key: string]: never; }>;


export type ErGetAdditionalEmailFromMyExamCardQuery = { __typename?: 'Query', erGetMyExamCard: { __typename?: 'ExamCard', additionalEmail: string | null } };

export type ErGetExamEventByCardIdQueryVariables = Exact<{
  cardId: Scalars['String']['input'];
}>;


export type ErGetExamEventByCardIdQuery = { __typename?: 'Query', erGetExamEventByCardId: { __typename?: 'ExamEvent', id: string, title: string, subTitle: string | null, type: Exam_Event_Type | null, metadata: any | null, startDate: Date | null, endDate: Date | null, coverImageUrl: string | null, postponeDurationInMs: number | null, exam: { __typename?: 'Exam', id: string, title: string, metadata: any | null } | null } };

export type ErGetExamEventMetadataByCardIdQueryVariables = Exact<{
  cardId: Scalars['String']['input'];
}>;


export type ErGetExamEventMetadataByCardIdQuery = { __typename?: 'Query', erGetExamEventByCardId: { __typename?: 'ExamEvent', metadata: any | null } };

export type ErGetDownloadSignedUrlForMyAttachDocumentQueryVariables = Exact<{
  examCardId: Scalars['String']['input'];
}>;


export type ErGetDownloadSignedUrlForMyAttachDocumentQuery = { __typename?: 'Query', erGetDownloadSignedUrlForMyAttachDocument: { __typename?: 'GetDownloadSignedUrlForMyAttachDocumentResult', signedUrl: string } };

export type ErSubmitExamPaperMutationVariables = Exact<{
  submitExamInput: SubmitExamInput;
}>;


export type ErSubmitExamPaperMutation = { __typename?: 'Mutation', erSubmitExamPaper: { __typename?: 'SubmitExamPaperResult', isSuccess: boolean, errorCode: SubmitExamPaperErrorCode | null, message: string | null, examPaper: { __typename?: 'ExamPaper', id: string, examId: string, examCardId: string, status: ExamPaperStatus } | null } };

export type ErExamRoomUpdateExamPaperMutationVariables = Exact<{
  examRoomExamPaperItems: Array<ExamRoomExamPaperItemInput> | ExamRoomExamPaperItemInput;
}>;


export type ErExamRoomUpdateExamPaperMutation = { __typename?: 'Mutation', erExamRoomUpdateExamPaper: { __typename?: 'ExamRoomAnswer', examPaperId: string } };

export type GetMyCurrentExamPaperQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyCurrentExamPaperQuery = { __typename?: 'Query', erGetMyCurrentExamPaper: { __typename?: 'ExamPaper', id: string, examId: string, status: ExamPaperStatus, totalQuestions: number, examPaperItems: Array<{ __typename?: 'ExamPaperItem', id: string, order: number, question: { __typename?: 'Question', id: string, question: string, type: QbQuestionType, metadata: any | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, category: QbTagCategory }> } | null }> } };

export type GetExamResultByCardIdQueryVariables = Exact<{
  examCardId: Scalars['String']['input'];
}>;


export type GetExamResultByCardIdQuery = { __typename?: 'Query', erGetExamResultByCardId: { __typename?: 'ExamResult', isPassed: boolean } | null };

export type GetExamResultCompletedByCardIdQueryVariables = Exact<{
  examCardId: Scalars['String']['input'];
}>;


export type GetExamResultCompletedByCardIdQuery = { __typename?: 'Query', erGetExamResultByCardId: { __typename?: 'ExamResult', examCardId: string, id: string } | null };

export type ErStartExamInEventMutationVariables = Exact<{
  input: StartExamInEventInput;
}>;


export type ErStartExamInEventMutation = { __typename?: 'Mutation', erStartExamInEvent: { __typename?: 'StartExamInEvent', message: string, errorCode: StartExamErrorCode | null, success: boolean, examSession: { __typename?: 'ExamSession', id: string, examPaperId: string, examEventId: string | null, startedAt: Date, endedAt: Date | null, examRoomAnswer: { __typename?: 'ExamRoomAnswer', examRoomExamPaperItems: Array<{ __typename?: 'ExamRoomExamPaperItem', examPaperItemId: string, questionId: string | null, refId: string | null, answer: any, isBookmark: boolean }> | null } | null } | null } };

export type ErBackToExamRoomMutationVariables = Exact<{
  input: BackToExamRoomInput;
}>;


export type ErBackToExamRoomMutation = { __typename?: 'Mutation', erBackToExamRoom: { __typename?: 'ExamSession', id: string, examPaperId: string, examEventId: string | null, startedAt: Date, endedAt: Date | null, examRoomAnswer: { __typename?: 'ExamRoomAnswer', examRoomExamPaperItems: Array<{ __typename?: 'ExamRoomExamPaperItem', examPaperItemId: string, questionId: string | null, refId: string | null, answer: any, isBookmark: boolean }> | null } | null } };

export type ErCheckExamStatusByExamCardIdQueryVariables = Exact<{
  examCardId: Scalars['String']['input'];
}>;


export type ErCheckExamStatusByExamCardIdQuery = { __typename?: 'Query', erCheckExamStatusByExamCardId: { __typename?: 'ExamSession', id: string } | null };

export type ErGetExamSessionAnswerQueryVariables = Exact<{ [key: string]: never; }>;


export type ErGetExamSessionAnswerQuery = { __typename?: 'Query', erGetExamSessionAnswer: { __typename?: 'ExamSession', id: string, examPaperId: string, examEventId: string | null, startedAt: Date, endedAt: Date | null, examRoomAnswer: { __typename?: 'ExamRoomAnswer', examRoomExamPaperItems: Array<{ __typename?: 'ExamRoomExamPaperItem', examPaperItemId: string, questionId: string | null, refId: string | null, answer: any, isBookmark: boolean }> | null } | null } };

export type ErGetMyExaminationTimeQueryVariables = Exact<{
  examCardId: Scalars['String']['input'];
}>;


export type ErGetMyExaminationTimeQuery = { __typename?: 'Query', erGetMyExaminationTime: { __typename?: 'MyExaminationTime', examinationTime: Array<{ __typename?: 'ExaminationTime', current: boolean, extraDurationInMs: number, postponedDurationInMs: number, totalManualExtendedDurationInMs: number, round: number }> } };

export type GetExamsByIdsQueryVariables = Exact<{
  examIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetExamsByIdsQuery = { __typename?: 'Query', erGetExamsByIds: Array<{ __typename?: 'Exam', id: string, metadata: any | null, title: string, totalQuestions: number | null }> };

export type ErExamRoomGetExamQueryVariables = Exact<{ [key: string]: never; }>;


export type ErExamRoomGetExamQuery = { __typename?: 'Query', erExamRoomGetExam: { __typename?: 'Exam', id: string, title: string, ownerCode: string, type: Exam_Type | null, totalQuestions: number | null, fullScore: number, metadata: any | null, tags: Array<{ __typename?: 'ExamTag', id: string, name: string, category: QbTagCategory }> | null, examItems: Array<{ __typename?: 'ExamItem', id: string, order: number, question: { __typename?: 'Question', id: string, question: string, type: QbQuestionType, metadata: any | null, tags: Array<{ __typename?: 'QuestionTag', id: string, name: string, category: QbTagCategory }> } | null }> } };

export type ErGetDownloadSignedUrlForQuestionsQueryVariables = Exact<{
  input: GetDownloadSignedUrlForQuestionsInput;
}>;


export type ErGetDownloadSignedUrlForQuestionsQuery = { __typename?: 'Query', erGetDownloadSignedUrlForQuestions: { __typename?: 'GetDownloadSignedUrlForQuestionsResult', signedUrls: any } | null };

export type ErSaveQuestionnaireMutationVariables = Exact<{
  input: SaveQuestionnaireInput;
}>;


export type ErSaveQuestionnaireMutation = { __typename?: 'Mutation', erSaveQuestionnaire: { __typename?: 'QuestionnaireDocument', documentId: string, questionnaire: any } };

export type Exam_Session_FragmentFragment = { __typename?: 'ExamSession', id: string, examPaperId: string, examEventId: string | null, startedAt: Date, endedAt: Date | null, examRoomAnswer: { __typename?: 'ExamRoomAnswer', examRoomExamPaperItems: Array<{ __typename?: 'ExamRoomExamPaperItem', examPaperItemId: string, questionId: string | null, refId: string | null, answer: any, isBookmark: boolean }> | null } | null };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', erLogout: { __typename?: 'Logout', success: boolean, message: string } };

export type LoginMutationVariables = Exact<{
  input: LoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', erLogin: { __typename?: 'Login', token: string | null, message: string, success: boolean, errorCode: LoginErrorCode | null, examineeInfo: { __typename?: 'ExamineeInfo', isDisplayResult: boolean, hasCertificate: boolean, isPassed: boolean | null, title: string, firstName: string, lastName: string, middleName: string | null } | null } };

export type CluAcceptPrivacyPolicyMutationVariables = Exact<{
  acceptPrivacyPolicyInput: AcceptPrivacyPolicyInput;
}>;


export type CluAcceptPrivacyPolicyMutation = { __typename?: 'Mutation', cluAcceptPrivacyPolicy: { __typename?: 'AcceptPrivacyPolicyOutput', userPrivacyPolicyAcceptance: { __typename?: 'UserPrivacyPolicyAcceptance', id: string, userId: string, policyId: string, isAccepted: boolean, acceptedAt: Date | null, privacyPolicy: { __typename?: 'PrivacyPolicy', id: string, version: string, documentUrl: string, description: string, isActive: boolean } } } };

export type CluAcceptTermAndConditionMutationVariables = Exact<{
  acceptTermAndConditionInput: AcceptTermAndConditionInput;
}>;


export type CluAcceptTermAndConditionMutation = { __typename?: 'Mutation', cluAcceptTermAndCondition: { __typename?: 'AcceptTermAndConditionOutput', userTermAndConditionAcceptance: { __typename?: 'UserTermAndConditionAcceptance', id: string, userId: string, termAndConditionId: string, isAccepted: boolean, acceptedAt: Date | null } } };

export type CluGetMyProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type CluGetMyProfileQuery = { __typename?: 'Query', cluGetMyProfile: { __typename?: 'ClientUser', id: string, title: string, firstname: string, lastname: string, email: string, idNumber: string, idType: IdType, imageUrl: string | null, expiredAt: Date, enabledAt: Date | null, status: UserStratus } };

export type GetLatestActivePrivacyPolicyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLatestActivePrivacyPolicyQuery = { __typename?: 'Query', cluGetLatestActivePrivacyPolicy: { __typename?: 'GetLatestActivePrivacyPolicyOutput', privacyPolicy: { __typename?: 'PrivacyPolicy', id: string, version: string, documentUrl: string, description: string, isActive: boolean, createdAt: Date, updatedAt: Date } } };

export type CheckUserAcceptanceForLatestPrivacyPolicyQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckUserAcceptanceForLatestPrivacyPolicyQuery = { __typename?: 'Query', cluCheckUserAcceptanceForLatestPrivacyPolicy: { __typename?: 'CheckUserAcceptanceForLatestPrivacyPolicyOutput', isAccepted: boolean } };

export type GetLatestActiveTermAndConditionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLatestActiveTermAndConditionQuery = { __typename?: 'Query', cluGetLatestActiveTermAndCondition: { __typename?: 'GetLatestActiveTermAndConditionOutput', termAndCondition: { __typename?: 'TermAndCondition', id: string, version: string, documentUrl: string, description: string, isActive: boolean, createdAt: Date, updatedAt: Date } } };

export type CheckUserAcceptanceForLatestTermAndConditionQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckUserAcceptanceForLatestTermAndConditionQuery = { __typename?: 'Query', cluCheckUserAcceptanceForLatestTermAndCondition: { __typename?: 'CheckUserAcceptanceForLatestTermAndConditionOutput', isAccepted: boolean } };

export type CluGetUserImageDownloadSignedUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type CluGetUserImageDownloadSignedUrlQuery = { __typename?: 'Query', cluGetUserImageDownloadSignedUrl: { __typename?: 'GetUserImageDownloadSignedUrlOutput', signedUrls: any } };

export const Exam_Session_FragmentFragmentDoc = gql`
    fragment EXAM_SESSION_FRAGMENT on ExamSession {
  id
  examPaperId
  examEventId
  startedAt
  endedAt
  examRoomAnswer {
    examRoomExamPaperItems {
      examPaperItemId
      questionId
      refId
      answer
      isBookmark
    }
  }
}
    `;
export const ErUpdateExamCardAdditionalEmailDocument = gql`
    mutation erUpdateExamCardAdditionalEmail($examCardId: String!, $email: String!) {
  erUpdateExamCardAdditionalEmail(examCardId: $examCardId, email: $email) {
    additionalEmail
  }
}
    `;
export type ErUpdateExamCardAdditionalEmailMutationFn = Apollo.MutationFunction<ErUpdateExamCardAdditionalEmailMutation, ErUpdateExamCardAdditionalEmailMutationVariables>;

/**
 * __useErUpdateExamCardAdditionalEmailMutation__
 *
 * To run a mutation, you first call `useErUpdateExamCardAdditionalEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErUpdateExamCardAdditionalEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erUpdateExamCardAdditionalEmailMutation, { data, loading, error }] = useErUpdateExamCardAdditionalEmailMutation({
 *   variables: {
 *      examCardId: // value for 'examCardId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useErUpdateExamCardAdditionalEmailMutation(baseOptions?: Apollo.MutationHookOptions<ErUpdateExamCardAdditionalEmailMutation, ErUpdateExamCardAdditionalEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ErUpdateExamCardAdditionalEmailMutation, ErUpdateExamCardAdditionalEmailMutationVariables>(ErUpdateExamCardAdditionalEmailDocument, options);
      }
export type ErUpdateExamCardAdditionalEmailMutationHookResult = ReturnType<typeof useErUpdateExamCardAdditionalEmailMutation>;
export type ErUpdateExamCardAdditionalEmailMutationResult = Apollo.MutationResult<ErUpdateExamCardAdditionalEmailMutation>;
export type ErUpdateExamCardAdditionalEmailMutationOptions = Apollo.BaseMutationOptions<ErUpdateExamCardAdditionalEmailMutation, ErUpdateExamCardAdditionalEmailMutationVariables>;
export const ErGetMyExamCardDocument = gql`
    query erGetMyExamCard {
  erGetMyExamCard {
    id
    userId
    examEventId
    availableDate
    expiryDate
    metadata
    seatNumber
  }
}
    `;

/**
 * __useErGetMyExamCardQuery__
 *
 * To run a query within a React component, call `useErGetMyExamCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useErGetMyExamCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErGetMyExamCardQuery({
 *   variables: {
 *   },
 * });
 */
export function useErGetMyExamCardQuery(baseOptions?: Apollo.QueryHookOptions<ErGetMyExamCardQuery, ErGetMyExamCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ErGetMyExamCardQuery, ErGetMyExamCardQueryVariables>(ErGetMyExamCardDocument, options);
      }
export function useErGetMyExamCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErGetMyExamCardQuery, ErGetMyExamCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ErGetMyExamCardQuery, ErGetMyExamCardQueryVariables>(ErGetMyExamCardDocument, options);
        }
export function useErGetMyExamCardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ErGetMyExamCardQuery, ErGetMyExamCardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ErGetMyExamCardQuery, ErGetMyExamCardQueryVariables>(ErGetMyExamCardDocument, options);
        }
export type ErGetMyExamCardQueryHookResult = ReturnType<typeof useErGetMyExamCardQuery>;
export type ErGetMyExamCardLazyQueryHookResult = ReturnType<typeof useErGetMyExamCardLazyQuery>;
export type ErGetMyExamCardSuspenseQueryHookResult = ReturnType<typeof useErGetMyExamCardSuspenseQuery>;
export type ErGetMyExamCardQueryResult = Apollo.QueryResult<ErGetMyExamCardQuery, ErGetMyExamCardQueryVariables>;
export const ErGetAdditionalEmailFromMyExamCardDocument = gql`
    query erGetAdditionalEmailFromMyExamCard {
  erGetMyExamCard {
    additionalEmail
  }
}
    `;

/**
 * __useErGetAdditionalEmailFromMyExamCardQuery__
 *
 * To run a query within a React component, call `useErGetAdditionalEmailFromMyExamCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useErGetAdditionalEmailFromMyExamCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErGetAdditionalEmailFromMyExamCardQuery({
 *   variables: {
 *   },
 * });
 */
export function useErGetAdditionalEmailFromMyExamCardQuery(baseOptions?: Apollo.QueryHookOptions<ErGetAdditionalEmailFromMyExamCardQuery, ErGetAdditionalEmailFromMyExamCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ErGetAdditionalEmailFromMyExamCardQuery, ErGetAdditionalEmailFromMyExamCardQueryVariables>(ErGetAdditionalEmailFromMyExamCardDocument, options);
      }
export function useErGetAdditionalEmailFromMyExamCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErGetAdditionalEmailFromMyExamCardQuery, ErGetAdditionalEmailFromMyExamCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ErGetAdditionalEmailFromMyExamCardQuery, ErGetAdditionalEmailFromMyExamCardQueryVariables>(ErGetAdditionalEmailFromMyExamCardDocument, options);
        }
export function useErGetAdditionalEmailFromMyExamCardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ErGetAdditionalEmailFromMyExamCardQuery, ErGetAdditionalEmailFromMyExamCardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ErGetAdditionalEmailFromMyExamCardQuery, ErGetAdditionalEmailFromMyExamCardQueryVariables>(ErGetAdditionalEmailFromMyExamCardDocument, options);
        }
export type ErGetAdditionalEmailFromMyExamCardQueryHookResult = ReturnType<typeof useErGetAdditionalEmailFromMyExamCardQuery>;
export type ErGetAdditionalEmailFromMyExamCardLazyQueryHookResult = ReturnType<typeof useErGetAdditionalEmailFromMyExamCardLazyQuery>;
export type ErGetAdditionalEmailFromMyExamCardSuspenseQueryHookResult = ReturnType<typeof useErGetAdditionalEmailFromMyExamCardSuspenseQuery>;
export type ErGetAdditionalEmailFromMyExamCardQueryResult = Apollo.QueryResult<ErGetAdditionalEmailFromMyExamCardQuery, ErGetAdditionalEmailFromMyExamCardQueryVariables>;
export const ErGetExamEventByCardIdDocument = gql`
    query erGetExamEventByCardId($cardId: String!) {
  erGetExamEventByCardId(cardId: $cardId) {
    id
    title
    subTitle
    type
    metadata
    startDate
    endDate
    coverImageUrl
    postponeDurationInMs
    exam {
      id
      title
      metadata
    }
  }
}
    `;

/**
 * __useErGetExamEventByCardIdQuery__
 *
 * To run a query within a React component, call `useErGetExamEventByCardIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useErGetExamEventByCardIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErGetExamEventByCardIdQuery({
 *   variables: {
 *      cardId: // value for 'cardId'
 *   },
 * });
 */
export function useErGetExamEventByCardIdQuery(baseOptions: Apollo.QueryHookOptions<ErGetExamEventByCardIdQuery, ErGetExamEventByCardIdQueryVariables> & ({ variables: ErGetExamEventByCardIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ErGetExamEventByCardIdQuery, ErGetExamEventByCardIdQueryVariables>(ErGetExamEventByCardIdDocument, options);
      }
export function useErGetExamEventByCardIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErGetExamEventByCardIdQuery, ErGetExamEventByCardIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ErGetExamEventByCardIdQuery, ErGetExamEventByCardIdQueryVariables>(ErGetExamEventByCardIdDocument, options);
        }
export function useErGetExamEventByCardIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ErGetExamEventByCardIdQuery, ErGetExamEventByCardIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ErGetExamEventByCardIdQuery, ErGetExamEventByCardIdQueryVariables>(ErGetExamEventByCardIdDocument, options);
        }
export type ErGetExamEventByCardIdQueryHookResult = ReturnType<typeof useErGetExamEventByCardIdQuery>;
export type ErGetExamEventByCardIdLazyQueryHookResult = ReturnType<typeof useErGetExamEventByCardIdLazyQuery>;
export type ErGetExamEventByCardIdSuspenseQueryHookResult = ReturnType<typeof useErGetExamEventByCardIdSuspenseQuery>;
export type ErGetExamEventByCardIdQueryResult = Apollo.QueryResult<ErGetExamEventByCardIdQuery, ErGetExamEventByCardIdQueryVariables>;
export const ErGetExamEventMetadataByCardIdDocument = gql`
    query erGetExamEventMetadataByCardId($cardId: String!) {
  erGetExamEventByCardId(cardId: $cardId) {
    metadata
  }
}
    `;

/**
 * __useErGetExamEventMetadataByCardIdQuery__
 *
 * To run a query within a React component, call `useErGetExamEventMetadataByCardIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useErGetExamEventMetadataByCardIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErGetExamEventMetadataByCardIdQuery({
 *   variables: {
 *      cardId: // value for 'cardId'
 *   },
 * });
 */
export function useErGetExamEventMetadataByCardIdQuery(baseOptions: Apollo.QueryHookOptions<ErGetExamEventMetadataByCardIdQuery, ErGetExamEventMetadataByCardIdQueryVariables> & ({ variables: ErGetExamEventMetadataByCardIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ErGetExamEventMetadataByCardIdQuery, ErGetExamEventMetadataByCardIdQueryVariables>(ErGetExamEventMetadataByCardIdDocument, options);
      }
export function useErGetExamEventMetadataByCardIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErGetExamEventMetadataByCardIdQuery, ErGetExamEventMetadataByCardIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ErGetExamEventMetadataByCardIdQuery, ErGetExamEventMetadataByCardIdQueryVariables>(ErGetExamEventMetadataByCardIdDocument, options);
        }
export function useErGetExamEventMetadataByCardIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ErGetExamEventMetadataByCardIdQuery, ErGetExamEventMetadataByCardIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ErGetExamEventMetadataByCardIdQuery, ErGetExamEventMetadataByCardIdQueryVariables>(ErGetExamEventMetadataByCardIdDocument, options);
        }
export type ErGetExamEventMetadataByCardIdQueryHookResult = ReturnType<typeof useErGetExamEventMetadataByCardIdQuery>;
export type ErGetExamEventMetadataByCardIdLazyQueryHookResult = ReturnType<typeof useErGetExamEventMetadataByCardIdLazyQuery>;
export type ErGetExamEventMetadataByCardIdSuspenseQueryHookResult = ReturnType<typeof useErGetExamEventMetadataByCardIdSuspenseQuery>;
export type ErGetExamEventMetadataByCardIdQueryResult = Apollo.QueryResult<ErGetExamEventMetadataByCardIdQuery, ErGetExamEventMetadataByCardIdQueryVariables>;
export const ErGetDownloadSignedUrlForMyAttachDocumentDocument = gql`
    query erGetDownloadSignedUrlForMyAttachDocument($examCardId: String!) {
  erGetDownloadSignedUrlForMyAttachDocument(examCardId: $examCardId) {
    signedUrl
  }
}
    `;

/**
 * __useErGetDownloadSignedUrlForMyAttachDocumentQuery__
 *
 * To run a query within a React component, call `useErGetDownloadSignedUrlForMyAttachDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useErGetDownloadSignedUrlForMyAttachDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErGetDownloadSignedUrlForMyAttachDocumentQuery({
 *   variables: {
 *      examCardId: // value for 'examCardId'
 *   },
 * });
 */
export function useErGetDownloadSignedUrlForMyAttachDocumentQuery(baseOptions: Apollo.QueryHookOptions<ErGetDownloadSignedUrlForMyAttachDocumentQuery, ErGetDownloadSignedUrlForMyAttachDocumentQueryVariables> & ({ variables: ErGetDownloadSignedUrlForMyAttachDocumentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ErGetDownloadSignedUrlForMyAttachDocumentQuery, ErGetDownloadSignedUrlForMyAttachDocumentQueryVariables>(ErGetDownloadSignedUrlForMyAttachDocumentDocument, options);
      }
export function useErGetDownloadSignedUrlForMyAttachDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErGetDownloadSignedUrlForMyAttachDocumentQuery, ErGetDownloadSignedUrlForMyAttachDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ErGetDownloadSignedUrlForMyAttachDocumentQuery, ErGetDownloadSignedUrlForMyAttachDocumentQueryVariables>(ErGetDownloadSignedUrlForMyAttachDocumentDocument, options);
        }
export function useErGetDownloadSignedUrlForMyAttachDocumentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ErGetDownloadSignedUrlForMyAttachDocumentQuery, ErGetDownloadSignedUrlForMyAttachDocumentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ErGetDownloadSignedUrlForMyAttachDocumentQuery, ErGetDownloadSignedUrlForMyAttachDocumentQueryVariables>(ErGetDownloadSignedUrlForMyAttachDocumentDocument, options);
        }
export type ErGetDownloadSignedUrlForMyAttachDocumentQueryHookResult = ReturnType<typeof useErGetDownloadSignedUrlForMyAttachDocumentQuery>;
export type ErGetDownloadSignedUrlForMyAttachDocumentLazyQueryHookResult = ReturnType<typeof useErGetDownloadSignedUrlForMyAttachDocumentLazyQuery>;
export type ErGetDownloadSignedUrlForMyAttachDocumentSuspenseQueryHookResult = ReturnType<typeof useErGetDownloadSignedUrlForMyAttachDocumentSuspenseQuery>;
export type ErGetDownloadSignedUrlForMyAttachDocumentQueryResult = Apollo.QueryResult<ErGetDownloadSignedUrlForMyAttachDocumentQuery, ErGetDownloadSignedUrlForMyAttachDocumentQueryVariables>;
export const ErSubmitExamPaperDocument = gql`
    mutation erSubmitExamPaper($submitExamInput: SubmitExamInput!) {
  erSubmitExamPaper(submitExamInput: $submitExamInput) {
    isSuccess
    errorCode
    message
    examPaper {
      id
      examId
      examCardId
      status
    }
  }
}
    `;
export type ErSubmitExamPaperMutationFn = Apollo.MutationFunction<ErSubmitExamPaperMutation, ErSubmitExamPaperMutationVariables>;

/**
 * __useErSubmitExamPaperMutation__
 *
 * To run a mutation, you first call `useErSubmitExamPaperMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErSubmitExamPaperMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erSubmitExamPaperMutation, { data, loading, error }] = useErSubmitExamPaperMutation({
 *   variables: {
 *      submitExamInput: // value for 'submitExamInput'
 *   },
 * });
 */
export function useErSubmitExamPaperMutation(baseOptions?: Apollo.MutationHookOptions<ErSubmitExamPaperMutation, ErSubmitExamPaperMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ErSubmitExamPaperMutation, ErSubmitExamPaperMutationVariables>(ErSubmitExamPaperDocument, options);
      }
export type ErSubmitExamPaperMutationHookResult = ReturnType<typeof useErSubmitExamPaperMutation>;
export type ErSubmitExamPaperMutationResult = Apollo.MutationResult<ErSubmitExamPaperMutation>;
export type ErSubmitExamPaperMutationOptions = Apollo.BaseMutationOptions<ErSubmitExamPaperMutation, ErSubmitExamPaperMutationVariables>;
export const ErExamRoomUpdateExamPaperDocument = gql`
    mutation erExamRoomUpdateExamPaper($examRoomExamPaperItems: [ExamRoomExamPaperItemInput!]!) {
  erExamRoomUpdateExamPaper(examRoomExamPaperItems: $examRoomExamPaperItems) {
    examPaperId
  }
}
    `;
export type ErExamRoomUpdateExamPaperMutationFn = Apollo.MutationFunction<ErExamRoomUpdateExamPaperMutation, ErExamRoomUpdateExamPaperMutationVariables>;

/**
 * __useErExamRoomUpdateExamPaperMutation__
 *
 * To run a mutation, you first call `useErExamRoomUpdateExamPaperMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErExamRoomUpdateExamPaperMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erExamRoomUpdateExamPaperMutation, { data, loading, error }] = useErExamRoomUpdateExamPaperMutation({
 *   variables: {
 *      examRoomExamPaperItems: // value for 'examRoomExamPaperItems'
 *   },
 * });
 */
export function useErExamRoomUpdateExamPaperMutation(baseOptions?: Apollo.MutationHookOptions<ErExamRoomUpdateExamPaperMutation, ErExamRoomUpdateExamPaperMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ErExamRoomUpdateExamPaperMutation, ErExamRoomUpdateExamPaperMutationVariables>(ErExamRoomUpdateExamPaperDocument, options);
      }
export type ErExamRoomUpdateExamPaperMutationHookResult = ReturnType<typeof useErExamRoomUpdateExamPaperMutation>;
export type ErExamRoomUpdateExamPaperMutationResult = Apollo.MutationResult<ErExamRoomUpdateExamPaperMutation>;
export type ErExamRoomUpdateExamPaperMutationOptions = Apollo.BaseMutationOptions<ErExamRoomUpdateExamPaperMutation, ErExamRoomUpdateExamPaperMutationVariables>;
export const GetMyCurrentExamPaperDocument = gql`
    query getMyCurrentExamPaper {
  erGetMyCurrentExamPaper {
    id
    examId
    status
    totalQuestions
    examPaperItems {
      id
      order
      question {
        id
        question
        type
        metadata
        tags {
          id
          name
          category
        }
      }
    }
  }
}
    `;

/**
 * __useGetMyCurrentExamPaperQuery__
 *
 * To run a query within a React component, call `useGetMyCurrentExamPaperQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyCurrentExamPaperQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyCurrentExamPaperQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyCurrentExamPaperQuery(baseOptions?: Apollo.QueryHookOptions<GetMyCurrentExamPaperQuery, GetMyCurrentExamPaperQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyCurrentExamPaperQuery, GetMyCurrentExamPaperQueryVariables>(GetMyCurrentExamPaperDocument, options);
      }
export function useGetMyCurrentExamPaperLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyCurrentExamPaperQuery, GetMyCurrentExamPaperQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyCurrentExamPaperQuery, GetMyCurrentExamPaperQueryVariables>(GetMyCurrentExamPaperDocument, options);
        }
export function useGetMyCurrentExamPaperSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyCurrentExamPaperQuery, GetMyCurrentExamPaperQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyCurrentExamPaperQuery, GetMyCurrentExamPaperQueryVariables>(GetMyCurrentExamPaperDocument, options);
        }
export type GetMyCurrentExamPaperQueryHookResult = ReturnType<typeof useGetMyCurrentExamPaperQuery>;
export type GetMyCurrentExamPaperLazyQueryHookResult = ReturnType<typeof useGetMyCurrentExamPaperLazyQuery>;
export type GetMyCurrentExamPaperSuspenseQueryHookResult = ReturnType<typeof useGetMyCurrentExamPaperSuspenseQuery>;
export type GetMyCurrentExamPaperQueryResult = Apollo.QueryResult<GetMyCurrentExamPaperQuery, GetMyCurrentExamPaperQueryVariables>;
export const GetExamResultByCardIdDocument = gql`
    query getExamResultByCardId($examCardId: String!) {
  erGetExamResultByCardId(examCardId: $examCardId) {
    isPassed
  }
}
    `;

/**
 * __useGetExamResultByCardIdQuery__
 *
 * To run a query within a React component, call `useGetExamResultByCardIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExamResultByCardIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExamResultByCardIdQuery({
 *   variables: {
 *      examCardId: // value for 'examCardId'
 *   },
 * });
 */
export function useGetExamResultByCardIdQuery(baseOptions: Apollo.QueryHookOptions<GetExamResultByCardIdQuery, GetExamResultByCardIdQueryVariables> & ({ variables: GetExamResultByCardIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExamResultByCardIdQuery, GetExamResultByCardIdQueryVariables>(GetExamResultByCardIdDocument, options);
      }
export function useGetExamResultByCardIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExamResultByCardIdQuery, GetExamResultByCardIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExamResultByCardIdQuery, GetExamResultByCardIdQueryVariables>(GetExamResultByCardIdDocument, options);
        }
export function useGetExamResultByCardIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExamResultByCardIdQuery, GetExamResultByCardIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExamResultByCardIdQuery, GetExamResultByCardIdQueryVariables>(GetExamResultByCardIdDocument, options);
        }
export type GetExamResultByCardIdQueryHookResult = ReturnType<typeof useGetExamResultByCardIdQuery>;
export type GetExamResultByCardIdLazyQueryHookResult = ReturnType<typeof useGetExamResultByCardIdLazyQuery>;
export type GetExamResultByCardIdSuspenseQueryHookResult = ReturnType<typeof useGetExamResultByCardIdSuspenseQuery>;
export type GetExamResultByCardIdQueryResult = Apollo.QueryResult<GetExamResultByCardIdQuery, GetExamResultByCardIdQueryVariables>;
export const GetExamResultCompletedByCardIdDocument = gql`
    query getExamResultCompletedByCardId($examCardId: String!) {
  erGetExamResultByCardId(examCardId: $examCardId) {
    examCardId
    id
  }
}
    `;

/**
 * __useGetExamResultCompletedByCardIdQuery__
 *
 * To run a query within a React component, call `useGetExamResultCompletedByCardIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExamResultCompletedByCardIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExamResultCompletedByCardIdQuery({
 *   variables: {
 *      examCardId: // value for 'examCardId'
 *   },
 * });
 */
export function useGetExamResultCompletedByCardIdQuery(baseOptions: Apollo.QueryHookOptions<GetExamResultCompletedByCardIdQuery, GetExamResultCompletedByCardIdQueryVariables> & ({ variables: GetExamResultCompletedByCardIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExamResultCompletedByCardIdQuery, GetExamResultCompletedByCardIdQueryVariables>(GetExamResultCompletedByCardIdDocument, options);
      }
export function useGetExamResultCompletedByCardIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExamResultCompletedByCardIdQuery, GetExamResultCompletedByCardIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExamResultCompletedByCardIdQuery, GetExamResultCompletedByCardIdQueryVariables>(GetExamResultCompletedByCardIdDocument, options);
        }
export function useGetExamResultCompletedByCardIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExamResultCompletedByCardIdQuery, GetExamResultCompletedByCardIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExamResultCompletedByCardIdQuery, GetExamResultCompletedByCardIdQueryVariables>(GetExamResultCompletedByCardIdDocument, options);
        }
export type GetExamResultCompletedByCardIdQueryHookResult = ReturnType<typeof useGetExamResultCompletedByCardIdQuery>;
export type GetExamResultCompletedByCardIdLazyQueryHookResult = ReturnType<typeof useGetExamResultCompletedByCardIdLazyQuery>;
export type GetExamResultCompletedByCardIdSuspenseQueryHookResult = ReturnType<typeof useGetExamResultCompletedByCardIdSuspenseQuery>;
export type GetExamResultCompletedByCardIdQueryResult = Apollo.QueryResult<GetExamResultCompletedByCardIdQuery, GetExamResultCompletedByCardIdQueryVariables>;
export const ErStartExamInEventDocument = gql`
    mutation erStartExamInEvent($input: StartExamInEventInput!) {
  erStartExamInEvent(input: $input) {
    examSession {
      ...EXAM_SESSION_FRAGMENT
    }
    message
    errorCode
    success
  }
}
    ${Exam_Session_FragmentFragmentDoc}`;
export type ErStartExamInEventMutationFn = Apollo.MutationFunction<ErStartExamInEventMutation, ErStartExamInEventMutationVariables>;

/**
 * __useErStartExamInEventMutation__
 *
 * To run a mutation, you first call `useErStartExamInEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErStartExamInEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erStartExamInEventMutation, { data, loading, error }] = useErStartExamInEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useErStartExamInEventMutation(baseOptions?: Apollo.MutationHookOptions<ErStartExamInEventMutation, ErStartExamInEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ErStartExamInEventMutation, ErStartExamInEventMutationVariables>(ErStartExamInEventDocument, options);
      }
export type ErStartExamInEventMutationHookResult = ReturnType<typeof useErStartExamInEventMutation>;
export type ErStartExamInEventMutationResult = Apollo.MutationResult<ErStartExamInEventMutation>;
export type ErStartExamInEventMutationOptions = Apollo.BaseMutationOptions<ErStartExamInEventMutation, ErStartExamInEventMutationVariables>;
export const ErBackToExamRoomDocument = gql`
    mutation erBackToExamRoom($input: BackToExamRoomInput!) {
  erBackToExamRoom(input: $input) {
    ...EXAM_SESSION_FRAGMENT
  }
}
    ${Exam_Session_FragmentFragmentDoc}`;
export type ErBackToExamRoomMutationFn = Apollo.MutationFunction<ErBackToExamRoomMutation, ErBackToExamRoomMutationVariables>;

/**
 * __useErBackToExamRoomMutation__
 *
 * To run a mutation, you first call `useErBackToExamRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErBackToExamRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erBackToExamRoomMutation, { data, loading, error }] = useErBackToExamRoomMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useErBackToExamRoomMutation(baseOptions?: Apollo.MutationHookOptions<ErBackToExamRoomMutation, ErBackToExamRoomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ErBackToExamRoomMutation, ErBackToExamRoomMutationVariables>(ErBackToExamRoomDocument, options);
      }
export type ErBackToExamRoomMutationHookResult = ReturnType<typeof useErBackToExamRoomMutation>;
export type ErBackToExamRoomMutationResult = Apollo.MutationResult<ErBackToExamRoomMutation>;
export type ErBackToExamRoomMutationOptions = Apollo.BaseMutationOptions<ErBackToExamRoomMutation, ErBackToExamRoomMutationVariables>;
export const ErCheckExamStatusByExamCardIdDocument = gql`
    query erCheckExamStatusByExamCardId($examCardId: String!) {
  erCheckExamStatusByExamCardId(examCardId: $examCardId) {
    id
  }
}
    `;

/**
 * __useErCheckExamStatusByExamCardIdQuery__
 *
 * To run a query within a React component, call `useErCheckExamStatusByExamCardIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useErCheckExamStatusByExamCardIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErCheckExamStatusByExamCardIdQuery({
 *   variables: {
 *      examCardId: // value for 'examCardId'
 *   },
 * });
 */
export function useErCheckExamStatusByExamCardIdQuery(baseOptions: Apollo.QueryHookOptions<ErCheckExamStatusByExamCardIdQuery, ErCheckExamStatusByExamCardIdQueryVariables> & ({ variables: ErCheckExamStatusByExamCardIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ErCheckExamStatusByExamCardIdQuery, ErCheckExamStatusByExamCardIdQueryVariables>(ErCheckExamStatusByExamCardIdDocument, options);
      }
export function useErCheckExamStatusByExamCardIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErCheckExamStatusByExamCardIdQuery, ErCheckExamStatusByExamCardIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ErCheckExamStatusByExamCardIdQuery, ErCheckExamStatusByExamCardIdQueryVariables>(ErCheckExamStatusByExamCardIdDocument, options);
        }
export function useErCheckExamStatusByExamCardIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ErCheckExamStatusByExamCardIdQuery, ErCheckExamStatusByExamCardIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ErCheckExamStatusByExamCardIdQuery, ErCheckExamStatusByExamCardIdQueryVariables>(ErCheckExamStatusByExamCardIdDocument, options);
        }
export type ErCheckExamStatusByExamCardIdQueryHookResult = ReturnType<typeof useErCheckExamStatusByExamCardIdQuery>;
export type ErCheckExamStatusByExamCardIdLazyQueryHookResult = ReturnType<typeof useErCheckExamStatusByExamCardIdLazyQuery>;
export type ErCheckExamStatusByExamCardIdSuspenseQueryHookResult = ReturnType<typeof useErCheckExamStatusByExamCardIdSuspenseQuery>;
export type ErCheckExamStatusByExamCardIdQueryResult = Apollo.QueryResult<ErCheckExamStatusByExamCardIdQuery, ErCheckExamStatusByExamCardIdQueryVariables>;
export const ErGetExamSessionAnswerDocument = gql`
    query erGetExamSessionAnswer {
  erGetExamSessionAnswer {
    ...EXAM_SESSION_FRAGMENT
  }
}
    ${Exam_Session_FragmentFragmentDoc}`;

/**
 * __useErGetExamSessionAnswerQuery__
 *
 * To run a query within a React component, call `useErGetExamSessionAnswerQuery` and pass it any options that fit your needs.
 * When your component renders, `useErGetExamSessionAnswerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErGetExamSessionAnswerQuery({
 *   variables: {
 *   },
 * });
 */
export function useErGetExamSessionAnswerQuery(baseOptions?: Apollo.QueryHookOptions<ErGetExamSessionAnswerQuery, ErGetExamSessionAnswerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ErGetExamSessionAnswerQuery, ErGetExamSessionAnswerQueryVariables>(ErGetExamSessionAnswerDocument, options);
      }
export function useErGetExamSessionAnswerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErGetExamSessionAnswerQuery, ErGetExamSessionAnswerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ErGetExamSessionAnswerQuery, ErGetExamSessionAnswerQueryVariables>(ErGetExamSessionAnswerDocument, options);
        }
export function useErGetExamSessionAnswerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ErGetExamSessionAnswerQuery, ErGetExamSessionAnswerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ErGetExamSessionAnswerQuery, ErGetExamSessionAnswerQueryVariables>(ErGetExamSessionAnswerDocument, options);
        }
export type ErGetExamSessionAnswerQueryHookResult = ReturnType<typeof useErGetExamSessionAnswerQuery>;
export type ErGetExamSessionAnswerLazyQueryHookResult = ReturnType<typeof useErGetExamSessionAnswerLazyQuery>;
export type ErGetExamSessionAnswerSuspenseQueryHookResult = ReturnType<typeof useErGetExamSessionAnswerSuspenseQuery>;
export type ErGetExamSessionAnswerQueryResult = Apollo.QueryResult<ErGetExamSessionAnswerQuery, ErGetExamSessionAnswerQueryVariables>;
export const ErGetMyExaminationTimeDocument = gql`
    query erGetMyExaminationTime($examCardId: String!) {
  erGetMyExaminationTime(examCardId: $examCardId) {
    examinationTime {
      current
      extraDurationInMs
      postponedDurationInMs
      totalManualExtendedDurationInMs
      round
    }
  }
}
    `;

/**
 * __useErGetMyExaminationTimeQuery__
 *
 * To run a query within a React component, call `useErGetMyExaminationTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useErGetMyExaminationTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErGetMyExaminationTimeQuery({
 *   variables: {
 *      examCardId: // value for 'examCardId'
 *   },
 * });
 */
export function useErGetMyExaminationTimeQuery(baseOptions: Apollo.QueryHookOptions<ErGetMyExaminationTimeQuery, ErGetMyExaminationTimeQueryVariables> & ({ variables: ErGetMyExaminationTimeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ErGetMyExaminationTimeQuery, ErGetMyExaminationTimeQueryVariables>(ErGetMyExaminationTimeDocument, options);
      }
export function useErGetMyExaminationTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErGetMyExaminationTimeQuery, ErGetMyExaminationTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ErGetMyExaminationTimeQuery, ErGetMyExaminationTimeQueryVariables>(ErGetMyExaminationTimeDocument, options);
        }
export function useErGetMyExaminationTimeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ErGetMyExaminationTimeQuery, ErGetMyExaminationTimeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ErGetMyExaminationTimeQuery, ErGetMyExaminationTimeQueryVariables>(ErGetMyExaminationTimeDocument, options);
        }
export type ErGetMyExaminationTimeQueryHookResult = ReturnType<typeof useErGetMyExaminationTimeQuery>;
export type ErGetMyExaminationTimeLazyQueryHookResult = ReturnType<typeof useErGetMyExaminationTimeLazyQuery>;
export type ErGetMyExaminationTimeSuspenseQueryHookResult = ReturnType<typeof useErGetMyExaminationTimeSuspenseQuery>;
export type ErGetMyExaminationTimeQueryResult = Apollo.QueryResult<ErGetMyExaminationTimeQuery, ErGetMyExaminationTimeQueryVariables>;
export const GetExamsByIdsDocument = gql`
    query getExamsByIds($examIds: [String!]!) {
  erGetExamsByIds(examIds: $examIds) {
    id
    metadata
    title
    totalQuestions
  }
}
    `;

/**
 * __useGetExamsByIdsQuery__
 *
 * To run a query within a React component, call `useGetExamsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExamsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExamsByIdsQuery({
 *   variables: {
 *      examIds: // value for 'examIds'
 *   },
 * });
 */
export function useGetExamsByIdsQuery(baseOptions: Apollo.QueryHookOptions<GetExamsByIdsQuery, GetExamsByIdsQueryVariables> & ({ variables: GetExamsByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExamsByIdsQuery, GetExamsByIdsQueryVariables>(GetExamsByIdsDocument, options);
      }
export function useGetExamsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExamsByIdsQuery, GetExamsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExamsByIdsQuery, GetExamsByIdsQueryVariables>(GetExamsByIdsDocument, options);
        }
export function useGetExamsByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExamsByIdsQuery, GetExamsByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExamsByIdsQuery, GetExamsByIdsQueryVariables>(GetExamsByIdsDocument, options);
        }
export type GetExamsByIdsQueryHookResult = ReturnType<typeof useGetExamsByIdsQuery>;
export type GetExamsByIdsLazyQueryHookResult = ReturnType<typeof useGetExamsByIdsLazyQuery>;
export type GetExamsByIdsSuspenseQueryHookResult = ReturnType<typeof useGetExamsByIdsSuspenseQuery>;
export type GetExamsByIdsQueryResult = Apollo.QueryResult<GetExamsByIdsQuery, GetExamsByIdsQueryVariables>;
export const ErExamRoomGetExamDocument = gql`
    query erExamRoomGetExam {
  erExamRoomGetExam {
    id
    title
    ownerCode
    type
    totalQuestions
    fullScore
    metadata
    tags {
      id
      name
      category
    }
    examItems {
      id
      order
      question {
        id
        question
        type
        metadata
        tags {
          id
          name
          category
        }
      }
    }
  }
}
    `;

/**
 * __useErExamRoomGetExamQuery__
 *
 * To run a query within a React component, call `useErExamRoomGetExamQuery` and pass it any options that fit your needs.
 * When your component renders, `useErExamRoomGetExamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErExamRoomGetExamQuery({
 *   variables: {
 *   },
 * });
 */
export function useErExamRoomGetExamQuery(baseOptions?: Apollo.QueryHookOptions<ErExamRoomGetExamQuery, ErExamRoomGetExamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ErExamRoomGetExamQuery, ErExamRoomGetExamQueryVariables>(ErExamRoomGetExamDocument, options);
      }
export function useErExamRoomGetExamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErExamRoomGetExamQuery, ErExamRoomGetExamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ErExamRoomGetExamQuery, ErExamRoomGetExamQueryVariables>(ErExamRoomGetExamDocument, options);
        }
export function useErExamRoomGetExamSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ErExamRoomGetExamQuery, ErExamRoomGetExamQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ErExamRoomGetExamQuery, ErExamRoomGetExamQueryVariables>(ErExamRoomGetExamDocument, options);
        }
export type ErExamRoomGetExamQueryHookResult = ReturnType<typeof useErExamRoomGetExamQuery>;
export type ErExamRoomGetExamLazyQueryHookResult = ReturnType<typeof useErExamRoomGetExamLazyQuery>;
export type ErExamRoomGetExamSuspenseQueryHookResult = ReturnType<typeof useErExamRoomGetExamSuspenseQuery>;
export type ErExamRoomGetExamQueryResult = Apollo.QueryResult<ErExamRoomGetExamQuery, ErExamRoomGetExamQueryVariables>;
export const ErGetDownloadSignedUrlForQuestionsDocument = gql`
    query ErGetDownloadSignedUrlForQuestions($input: GetDownloadSignedUrlForQuestionsInput!) {
  erGetDownloadSignedUrlForQuestions(input: $input) {
    signedUrls
  }
}
    `;

/**
 * __useErGetDownloadSignedUrlForQuestionsQuery__
 *
 * To run a query within a React component, call `useErGetDownloadSignedUrlForQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useErGetDownloadSignedUrlForQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErGetDownloadSignedUrlForQuestionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useErGetDownloadSignedUrlForQuestionsQuery(baseOptions: Apollo.QueryHookOptions<ErGetDownloadSignedUrlForQuestionsQuery, ErGetDownloadSignedUrlForQuestionsQueryVariables> & ({ variables: ErGetDownloadSignedUrlForQuestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ErGetDownloadSignedUrlForQuestionsQuery, ErGetDownloadSignedUrlForQuestionsQueryVariables>(ErGetDownloadSignedUrlForQuestionsDocument, options);
      }
export function useErGetDownloadSignedUrlForQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErGetDownloadSignedUrlForQuestionsQuery, ErGetDownloadSignedUrlForQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ErGetDownloadSignedUrlForQuestionsQuery, ErGetDownloadSignedUrlForQuestionsQueryVariables>(ErGetDownloadSignedUrlForQuestionsDocument, options);
        }
export function useErGetDownloadSignedUrlForQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ErGetDownloadSignedUrlForQuestionsQuery, ErGetDownloadSignedUrlForQuestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ErGetDownloadSignedUrlForQuestionsQuery, ErGetDownloadSignedUrlForQuestionsQueryVariables>(ErGetDownloadSignedUrlForQuestionsDocument, options);
        }
export type ErGetDownloadSignedUrlForQuestionsQueryHookResult = ReturnType<typeof useErGetDownloadSignedUrlForQuestionsQuery>;
export type ErGetDownloadSignedUrlForQuestionsLazyQueryHookResult = ReturnType<typeof useErGetDownloadSignedUrlForQuestionsLazyQuery>;
export type ErGetDownloadSignedUrlForQuestionsSuspenseQueryHookResult = ReturnType<typeof useErGetDownloadSignedUrlForQuestionsSuspenseQuery>;
export type ErGetDownloadSignedUrlForQuestionsQueryResult = Apollo.QueryResult<ErGetDownloadSignedUrlForQuestionsQuery, ErGetDownloadSignedUrlForQuestionsQueryVariables>;
export const ErSaveQuestionnaireDocument = gql`
    mutation erSaveQuestionnaire($input: SaveQuestionnaireInput!) {
  erSaveQuestionnaire(input: $input) {
    documentId
    questionnaire
  }
}
    `;
export type ErSaveQuestionnaireMutationFn = Apollo.MutationFunction<ErSaveQuestionnaireMutation, ErSaveQuestionnaireMutationVariables>;

/**
 * __useErSaveQuestionnaireMutation__
 *
 * To run a mutation, you first call `useErSaveQuestionnaireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useErSaveQuestionnaireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [erSaveQuestionnaireMutation, { data, loading, error }] = useErSaveQuestionnaireMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useErSaveQuestionnaireMutation(baseOptions?: Apollo.MutationHookOptions<ErSaveQuestionnaireMutation, ErSaveQuestionnaireMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ErSaveQuestionnaireMutation, ErSaveQuestionnaireMutationVariables>(ErSaveQuestionnaireDocument, options);
      }
export type ErSaveQuestionnaireMutationHookResult = ReturnType<typeof useErSaveQuestionnaireMutation>;
export type ErSaveQuestionnaireMutationResult = Apollo.MutationResult<ErSaveQuestionnaireMutation>;
export type ErSaveQuestionnaireMutationOptions = Apollo.BaseMutationOptions<ErSaveQuestionnaireMutation, ErSaveQuestionnaireMutationVariables>;
export const LogoutDocument = gql`
    mutation logout {
  erLogout {
    success
    message
  }
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const LoginDocument = gql`
    mutation login($input: LoginInput!) {
  erLogin(input: $input) {
    token
    message
    success
    errorCode
    examineeInfo {
      isDisplayResult
      hasCertificate
      isPassed
      title
      firstName
      lastName
      middleName
    }
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const CluAcceptPrivacyPolicyDocument = gql`
    mutation cluAcceptPrivacyPolicy($acceptPrivacyPolicyInput: AcceptPrivacyPolicyInput!) {
  cluAcceptPrivacyPolicy(AcceptPrivacyPolicyInput: $acceptPrivacyPolicyInput) {
    userPrivacyPolicyAcceptance {
      id
      userId
      policyId
      isAccepted
      acceptedAt
      privacyPolicy {
        id
        version
        documentUrl
        description
        isActive
      }
    }
  }
}
    `;
export type CluAcceptPrivacyPolicyMutationFn = Apollo.MutationFunction<CluAcceptPrivacyPolicyMutation, CluAcceptPrivacyPolicyMutationVariables>;

/**
 * __useCluAcceptPrivacyPolicyMutation__
 *
 * To run a mutation, you first call `useCluAcceptPrivacyPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCluAcceptPrivacyPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cluAcceptPrivacyPolicyMutation, { data, loading, error }] = useCluAcceptPrivacyPolicyMutation({
 *   variables: {
 *      acceptPrivacyPolicyInput: // value for 'acceptPrivacyPolicyInput'
 *   },
 * });
 */
export function useCluAcceptPrivacyPolicyMutation(baseOptions?: Apollo.MutationHookOptions<CluAcceptPrivacyPolicyMutation, CluAcceptPrivacyPolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CluAcceptPrivacyPolicyMutation, CluAcceptPrivacyPolicyMutationVariables>(CluAcceptPrivacyPolicyDocument, options);
      }
export type CluAcceptPrivacyPolicyMutationHookResult = ReturnType<typeof useCluAcceptPrivacyPolicyMutation>;
export type CluAcceptPrivacyPolicyMutationResult = Apollo.MutationResult<CluAcceptPrivacyPolicyMutation>;
export type CluAcceptPrivacyPolicyMutationOptions = Apollo.BaseMutationOptions<CluAcceptPrivacyPolicyMutation, CluAcceptPrivacyPolicyMutationVariables>;
export const CluAcceptTermAndConditionDocument = gql`
    mutation cluAcceptTermAndCondition($acceptTermAndConditionInput: AcceptTermAndConditionInput!) {
  cluAcceptTermAndCondition(
    AcceptTermAndConditionInput: $acceptTermAndConditionInput
  ) {
    userTermAndConditionAcceptance {
      id
      userId
      termAndConditionId
      isAccepted
      acceptedAt
    }
  }
}
    `;
export type CluAcceptTermAndConditionMutationFn = Apollo.MutationFunction<CluAcceptTermAndConditionMutation, CluAcceptTermAndConditionMutationVariables>;

/**
 * __useCluAcceptTermAndConditionMutation__
 *
 * To run a mutation, you first call `useCluAcceptTermAndConditionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCluAcceptTermAndConditionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cluAcceptTermAndConditionMutation, { data, loading, error }] = useCluAcceptTermAndConditionMutation({
 *   variables: {
 *      acceptTermAndConditionInput: // value for 'acceptTermAndConditionInput'
 *   },
 * });
 */
export function useCluAcceptTermAndConditionMutation(baseOptions?: Apollo.MutationHookOptions<CluAcceptTermAndConditionMutation, CluAcceptTermAndConditionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CluAcceptTermAndConditionMutation, CluAcceptTermAndConditionMutationVariables>(CluAcceptTermAndConditionDocument, options);
      }
export type CluAcceptTermAndConditionMutationHookResult = ReturnType<typeof useCluAcceptTermAndConditionMutation>;
export type CluAcceptTermAndConditionMutationResult = Apollo.MutationResult<CluAcceptTermAndConditionMutation>;
export type CluAcceptTermAndConditionMutationOptions = Apollo.BaseMutationOptions<CluAcceptTermAndConditionMutation, CluAcceptTermAndConditionMutationVariables>;
export const CluGetMyProfileDocument = gql`
    query CluGetMyProfile {
  cluGetMyProfile {
    id
    title
    firstname
    lastname
    email
    idNumber
    idType
    imageUrl
    expiredAt
    enabledAt
    status
  }
}
    `;

/**
 * __useCluGetMyProfileQuery__
 *
 * To run a query within a React component, call `useCluGetMyProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useCluGetMyProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCluGetMyProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useCluGetMyProfileQuery(baseOptions?: Apollo.QueryHookOptions<CluGetMyProfileQuery, CluGetMyProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CluGetMyProfileQuery, CluGetMyProfileQueryVariables>(CluGetMyProfileDocument, options);
      }
export function useCluGetMyProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CluGetMyProfileQuery, CluGetMyProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CluGetMyProfileQuery, CluGetMyProfileQueryVariables>(CluGetMyProfileDocument, options);
        }
export function useCluGetMyProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CluGetMyProfileQuery, CluGetMyProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CluGetMyProfileQuery, CluGetMyProfileQueryVariables>(CluGetMyProfileDocument, options);
        }
export type CluGetMyProfileQueryHookResult = ReturnType<typeof useCluGetMyProfileQuery>;
export type CluGetMyProfileLazyQueryHookResult = ReturnType<typeof useCluGetMyProfileLazyQuery>;
export type CluGetMyProfileSuspenseQueryHookResult = ReturnType<typeof useCluGetMyProfileSuspenseQuery>;
export type CluGetMyProfileQueryResult = Apollo.QueryResult<CluGetMyProfileQuery, CluGetMyProfileQueryVariables>;
export const GetLatestActivePrivacyPolicyDocument = gql`
    query GetLatestActivePrivacyPolicy {
  cluGetLatestActivePrivacyPolicy {
    privacyPolicy {
      id
      version
      documentUrl
      description
      isActive
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetLatestActivePrivacyPolicyQuery__
 *
 * To run a query within a React component, call `useGetLatestActivePrivacyPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestActivePrivacyPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestActivePrivacyPolicyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLatestActivePrivacyPolicyQuery(baseOptions?: Apollo.QueryHookOptions<GetLatestActivePrivacyPolicyQuery, GetLatestActivePrivacyPolicyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestActivePrivacyPolicyQuery, GetLatestActivePrivacyPolicyQueryVariables>(GetLatestActivePrivacyPolicyDocument, options);
      }
export function useGetLatestActivePrivacyPolicyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestActivePrivacyPolicyQuery, GetLatestActivePrivacyPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestActivePrivacyPolicyQuery, GetLatestActivePrivacyPolicyQueryVariables>(GetLatestActivePrivacyPolicyDocument, options);
        }
export function useGetLatestActivePrivacyPolicySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLatestActivePrivacyPolicyQuery, GetLatestActivePrivacyPolicyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLatestActivePrivacyPolicyQuery, GetLatestActivePrivacyPolicyQueryVariables>(GetLatestActivePrivacyPolicyDocument, options);
        }
export type GetLatestActivePrivacyPolicyQueryHookResult = ReturnType<typeof useGetLatestActivePrivacyPolicyQuery>;
export type GetLatestActivePrivacyPolicyLazyQueryHookResult = ReturnType<typeof useGetLatestActivePrivacyPolicyLazyQuery>;
export type GetLatestActivePrivacyPolicySuspenseQueryHookResult = ReturnType<typeof useGetLatestActivePrivacyPolicySuspenseQuery>;
export type GetLatestActivePrivacyPolicyQueryResult = Apollo.QueryResult<GetLatestActivePrivacyPolicyQuery, GetLatestActivePrivacyPolicyQueryVariables>;
export const CheckUserAcceptanceForLatestPrivacyPolicyDocument = gql`
    query CheckUserAcceptanceForLatestPrivacyPolicy {
  cluCheckUserAcceptanceForLatestPrivacyPolicy {
    isAccepted
  }
}
    `;

/**
 * __useCheckUserAcceptanceForLatestPrivacyPolicyQuery__
 *
 * To run a query within a React component, call `useCheckUserAcceptanceForLatestPrivacyPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckUserAcceptanceForLatestPrivacyPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckUserAcceptanceForLatestPrivacyPolicyQuery({
 *   variables: {
 *   },
 * });
 */
export function useCheckUserAcceptanceForLatestPrivacyPolicyQuery(baseOptions?: Apollo.QueryHookOptions<CheckUserAcceptanceForLatestPrivacyPolicyQuery, CheckUserAcceptanceForLatestPrivacyPolicyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckUserAcceptanceForLatestPrivacyPolicyQuery, CheckUserAcceptanceForLatestPrivacyPolicyQueryVariables>(CheckUserAcceptanceForLatestPrivacyPolicyDocument, options);
      }
export function useCheckUserAcceptanceForLatestPrivacyPolicyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckUserAcceptanceForLatestPrivacyPolicyQuery, CheckUserAcceptanceForLatestPrivacyPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckUserAcceptanceForLatestPrivacyPolicyQuery, CheckUserAcceptanceForLatestPrivacyPolicyQueryVariables>(CheckUserAcceptanceForLatestPrivacyPolicyDocument, options);
        }
export function useCheckUserAcceptanceForLatestPrivacyPolicySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckUserAcceptanceForLatestPrivacyPolicyQuery, CheckUserAcceptanceForLatestPrivacyPolicyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckUserAcceptanceForLatestPrivacyPolicyQuery, CheckUserAcceptanceForLatestPrivacyPolicyQueryVariables>(CheckUserAcceptanceForLatestPrivacyPolicyDocument, options);
        }
export type CheckUserAcceptanceForLatestPrivacyPolicyQueryHookResult = ReturnType<typeof useCheckUserAcceptanceForLatestPrivacyPolicyQuery>;
export type CheckUserAcceptanceForLatestPrivacyPolicyLazyQueryHookResult = ReturnType<typeof useCheckUserAcceptanceForLatestPrivacyPolicyLazyQuery>;
export type CheckUserAcceptanceForLatestPrivacyPolicySuspenseQueryHookResult = ReturnType<typeof useCheckUserAcceptanceForLatestPrivacyPolicySuspenseQuery>;
export type CheckUserAcceptanceForLatestPrivacyPolicyQueryResult = Apollo.QueryResult<CheckUserAcceptanceForLatestPrivacyPolicyQuery, CheckUserAcceptanceForLatestPrivacyPolicyQueryVariables>;
export const GetLatestActiveTermAndConditionDocument = gql`
    query GetLatestActiveTermAndCondition {
  cluGetLatestActiveTermAndCondition {
    termAndCondition {
      id
      version
      documentUrl
      description
      isActive
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetLatestActiveTermAndConditionQuery__
 *
 * To run a query within a React component, call `useGetLatestActiveTermAndConditionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestActiveTermAndConditionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestActiveTermAndConditionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLatestActiveTermAndConditionQuery(baseOptions?: Apollo.QueryHookOptions<GetLatestActiveTermAndConditionQuery, GetLatestActiveTermAndConditionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestActiveTermAndConditionQuery, GetLatestActiveTermAndConditionQueryVariables>(GetLatestActiveTermAndConditionDocument, options);
      }
export function useGetLatestActiveTermAndConditionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestActiveTermAndConditionQuery, GetLatestActiveTermAndConditionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestActiveTermAndConditionQuery, GetLatestActiveTermAndConditionQueryVariables>(GetLatestActiveTermAndConditionDocument, options);
        }
export function useGetLatestActiveTermAndConditionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLatestActiveTermAndConditionQuery, GetLatestActiveTermAndConditionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLatestActiveTermAndConditionQuery, GetLatestActiveTermAndConditionQueryVariables>(GetLatestActiveTermAndConditionDocument, options);
        }
export type GetLatestActiveTermAndConditionQueryHookResult = ReturnType<typeof useGetLatestActiveTermAndConditionQuery>;
export type GetLatestActiveTermAndConditionLazyQueryHookResult = ReturnType<typeof useGetLatestActiveTermAndConditionLazyQuery>;
export type GetLatestActiveTermAndConditionSuspenseQueryHookResult = ReturnType<typeof useGetLatestActiveTermAndConditionSuspenseQuery>;
export type GetLatestActiveTermAndConditionQueryResult = Apollo.QueryResult<GetLatestActiveTermAndConditionQuery, GetLatestActiveTermAndConditionQueryVariables>;
export const CheckUserAcceptanceForLatestTermAndConditionDocument = gql`
    query CheckUserAcceptanceForLatestTermAndCondition {
  cluCheckUserAcceptanceForLatestTermAndCondition {
    isAccepted
  }
}
    `;

/**
 * __useCheckUserAcceptanceForLatestTermAndConditionQuery__
 *
 * To run a query within a React component, call `useCheckUserAcceptanceForLatestTermAndConditionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckUserAcceptanceForLatestTermAndConditionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckUserAcceptanceForLatestTermAndConditionQuery({
 *   variables: {
 *   },
 * });
 */
export function useCheckUserAcceptanceForLatestTermAndConditionQuery(baseOptions?: Apollo.QueryHookOptions<CheckUserAcceptanceForLatestTermAndConditionQuery, CheckUserAcceptanceForLatestTermAndConditionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckUserAcceptanceForLatestTermAndConditionQuery, CheckUserAcceptanceForLatestTermAndConditionQueryVariables>(CheckUserAcceptanceForLatestTermAndConditionDocument, options);
      }
export function useCheckUserAcceptanceForLatestTermAndConditionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckUserAcceptanceForLatestTermAndConditionQuery, CheckUserAcceptanceForLatestTermAndConditionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckUserAcceptanceForLatestTermAndConditionQuery, CheckUserAcceptanceForLatestTermAndConditionQueryVariables>(CheckUserAcceptanceForLatestTermAndConditionDocument, options);
        }
export function useCheckUserAcceptanceForLatestTermAndConditionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckUserAcceptanceForLatestTermAndConditionQuery, CheckUserAcceptanceForLatestTermAndConditionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckUserAcceptanceForLatestTermAndConditionQuery, CheckUserAcceptanceForLatestTermAndConditionQueryVariables>(CheckUserAcceptanceForLatestTermAndConditionDocument, options);
        }
export type CheckUserAcceptanceForLatestTermAndConditionQueryHookResult = ReturnType<typeof useCheckUserAcceptanceForLatestTermAndConditionQuery>;
export type CheckUserAcceptanceForLatestTermAndConditionLazyQueryHookResult = ReturnType<typeof useCheckUserAcceptanceForLatestTermAndConditionLazyQuery>;
export type CheckUserAcceptanceForLatestTermAndConditionSuspenseQueryHookResult = ReturnType<typeof useCheckUserAcceptanceForLatestTermAndConditionSuspenseQuery>;
export type CheckUserAcceptanceForLatestTermAndConditionQueryResult = Apollo.QueryResult<CheckUserAcceptanceForLatestTermAndConditionQuery, CheckUserAcceptanceForLatestTermAndConditionQueryVariables>;
export const CluGetUserImageDownloadSignedUrlDocument = gql`
    query CluGetUserImageDownloadSignedUrl {
  cluGetUserImageDownloadSignedUrl {
    signedUrls
  }
}
    `;

/**
 * __useCluGetUserImageDownloadSignedUrlQuery__
 *
 * To run a query within a React component, call `useCluGetUserImageDownloadSignedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useCluGetUserImageDownloadSignedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCluGetUserImageDownloadSignedUrlQuery({
 *   variables: {
 *   },
 * });
 */
export function useCluGetUserImageDownloadSignedUrlQuery(baseOptions?: Apollo.QueryHookOptions<CluGetUserImageDownloadSignedUrlQuery, CluGetUserImageDownloadSignedUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CluGetUserImageDownloadSignedUrlQuery, CluGetUserImageDownloadSignedUrlQueryVariables>(CluGetUserImageDownloadSignedUrlDocument, options);
      }
export function useCluGetUserImageDownloadSignedUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CluGetUserImageDownloadSignedUrlQuery, CluGetUserImageDownloadSignedUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CluGetUserImageDownloadSignedUrlQuery, CluGetUserImageDownloadSignedUrlQueryVariables>(CluGetUserImageDownloadSignedUrlDocument, options);
        }
export function useCluGetUserImageDownloadSignedUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CluGetUserImageDownloadSignedUrlQuery, CluGetUserImageDownloadSignedUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CluGetUserImageDownloadSignedUrlQuery, CluGetUserImageDownloadSignedUrlQueryVariables>(CluGetUserImageDownloadSignedUrlDocument, options);
        }
export type CluGetUserImageDownloadSignedUrlQueryHookResult = ReturnType<typeof useCluGetUserImageDownloadSignedUrlQuery>;
export type CluGetUserImageDownloadSignedUrlLazyQueryHookResult = ReturnType<typeof useCluGetUserImageDownloadSignedUrlLazyQuery>;
export type CluGetUserImageDownloadSignedUrlSuspenseQueryHookResult = ReturnType<typeof useCluGetUserImageDownloadSignedUrlSuspenseQuery>;
export type CluGetUserImageDownloadSignedUrlQueryResult = Apollo.QueryResult<CluGetUserImageDownloadSignedUrlQuery, CluGetUserImageDownloadSignedUrlQueryVariables>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {}
};
      export default result;
    